/** How long the green "connected" bar stays at least before it flies into the top-bar chip. */
export const CALL_BAR_HANDOVER_MIN_MS = 2000;
